export default __webpack_public_path__ + "static/media/ac_chev.70fedcfd.bmp";